// Delegation also supports Shopify variant and theme-editor rerenders.
document.addEventListener('click', (event) => {
  const trigger = event.target.closest('.orkick-size-guide-button');
  if (!trigger) return;
  const template = trigger.nextElementSibling;
  if (!template?.matches('template.orkick-size-guide-template')) return;
  const dialog = template.content.firstElementChild.cloneNode(true);
  document.body.append(dialog);
  const previousOverflow = document.documentElement.style.overflow;
  document.documentElement.style.overflow = 'hidden';
  dialog.addEventListener('close', () => {
    document.documentElement.style.overflow = previousOverflow;
    dialog.remove();
    if (trigger.isConnected) trigger.focus();
  }, { once: true });
  dialog.querySelector('.orkick-size-guide-close').addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', (click) => {
    if (click.target !== dialog) return;
    const box = dialog.getBoundingClientRect();
    if (click.clientX < box.left || click.clientX > box.right || click.clientY < box.top || click.clientY > box.bottom) dialog.close();
  });
  dialog.showModal();
});
